import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, createTheme, ThemeProvider, CssBaseline, Box } from '@mui/material';
import './App.css';
import HomePage from './pages/HomePage';
import PlayersPage from './pages/PlayersPage';
import TeamsPage from './pages/TeamsPage';
import PlayerStatsPage from './pages/PlayerStatsPage';

// Import attribute pages
import AttributesPage from './pages/AttributesPage';
import AllAttributesPage from './pages/AllAttributesPage';
import BatterAttributesPage from './pages/BatterAttributesPage';
import PitcherAttributesPage from './pages/PitcherAttributesPage';

// Import all the new stat pages
import SeasonGeneralStatsPage from './pages/SeasonGeneralStatsPage';
import SeasonBattingStatsPage from './pages/SeasonBattingStatsPage';
import SeasonPitchingStatsPage from './pages/SeasonPitchingStatsPage';
import SeasonFieldingStatsPage from './pages/SeasonFieldingStatsPage';
import CareerGeneralStatsPage from './pages/CareerGeneralStatsPage';
import CareerBattingStatsPage from './pages/CareerBattingStatsPage';
import CareerPitchingStatsPage from './pages/CareerPitchingStatsPage';
import CareerFieldingStatsPage from './pages/CareerFieldingStatsPage';

// Define a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // A shade of blue
    },
    secondary: {
      main: '#dc004e', // A shade of red
    },
    background: {
      default: '#f4f6f8', // Light grey background
    },
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      marginBottom: '1rem',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      marginBottom: '0.8rem',
    },
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Prevent uppercase transformation
        },
      },
    },
  },
});

function App() {
  return (
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* Provides a consistent baseline for CSS */}
        <Router>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
              <Toolbar>
                <Typography 
                  variant="h6" 
                  component={Link} 
                  to="/"
                  sx={{ 
                    flexGrow: 1, 
                    textDecoration: 'none', 
                    color: 'inherit',
                    cursor: 'pointer',
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                >
                  PBE Data App
                </Typography>
                <Button color="inherit" component={Link} to="/players">
                  Players
                </Button>
                <Button color="inherit" component={Link} to="/teams">
                  Teams
                </Button>
                <Button color="inherit" component={Link} to="/attributes">
                  Attributes
                </Button>
                {/* <Button color="inherit" component={Link} to="/player-stats">
                  Statistics
                </Button> */}
                {/* Add more navigation buttons here */}
              </Toolbar>
            </AppBar>
          </Box>

          <Box sx={{ p: 3 }}> {/* Add padding to the main content area */}
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/players" element={<PlayersPage />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/player-stats" element={<PlayerStatsPage />} />

              {/* Attribute Routes */}
              <Route path="/attributes" element={<AttributesPage />} />
              <Route path="/attributes/all" element={<AllAttributesPage />} />
              <Route path="/attributes/batters" element={<BatterAttributesPage />} />
              <Route path="/attributes/pitchers" element={<PitcherAttributesPage />} />

              {/* Career Stats Routes */}
              <Route path="/stats/players/career/general" element={<CareerGeneralStatsPage />} />
              <Route path="/stats/players/career/batting" element={<CareerBattingStatsPage />} />
              <Route path="/stats/players/career/pitching" element={<CareerPitchingStatsPage />} />
              <Route path="/stats/players/career/fielding" element={<CareerFieldingStatsPage />} />

              {/* Season Stats Routes */}
              <Route path="/stats/players/season/general" element={<SeasonGeneralStatsPage />} />
              <Route path="/stats/players/season/batting" element={<SeasonBattingStatsPage />} />
              <Route path="/stats/players/season/pitching" element={<SeasonPitchingStatsPage />} />
              <Route path="/stats/players/season/fielding" element={<SeasonFieldingStatsPage />} />
            </Routes>
          </Box>
        </Router>
      </ThemeProvider>
  );
}

export default App;